import { Injectable, Inject, Component, NgZone } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { mergeMapTo } from 'rxjs/operators';
import { take } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs'
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { TamasAlunoService } from './tamas-aluno.service';
import {AlertaSimplesDialog} from './alerta-simples';

//import { CardapioService } from './cardapio.service';

@Injectable()
export class MessagingService {

  currentMessage = new BehaviorSubject(null);
  confirmDialogRef;
  constructor(public tmaService: TamasAlunoService,private dialog: MatDialog, private ngZone: NgZone, private md: MatDialog,
    private angularFireDB: AngularFireDatabase,
    private angularFireAuth: AngularFireAuth,
    private angularFireMessaging: AngularFireMessaging) {
    this.angularFireMessaging.messaging.subscribe(
      (_messaging) => {
        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      }
    )
  }

  // listen() {
  //   this.angularFireMessaging.messages
  //     .subscribe((message) => { console.log(message); });
  // }
  /**
   * update token in firebase database
   * 
   * @param userId userId as a key 
   * @param token token as a value
   */
  updateToken(userId, token) {
    // we can change this function to request our backend service
    // this.angularFireAuth.authState.pipe(take(1)).subscribe(
    //   () => {
    //     const data = {};
    //     data[userId] = token
    //     this.angularFireDB.object('fcmTokens/').update(data)
    //   })
  }

  /**
   * request permission for notification from firebase cloud messaging
   * 
   * @param userId userId
   */
  requestPermission(userId, tentativa) {
    console.log(userId);
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        console.log(token);
        if(token == null){
          this.tmaService.notificationAllowed(false);
          localStorage['tmsToken'] = JSON.stringify({ token: ''});
        }
        else{
          this.updateToken(userId, token);
          this.tmaService.usuarioToken = token;
          this.tmaService.notificationAllowed(true);
          localStorage['tmsToken'] = JSON.stringify({ token: token});
        }
       
      },
      (err) => {
        localStorage['tmsToken'] = JSON.stringify({ token: ''});
        if(tentativa == 0){
          localStorage.setItem('wantNotify', JSON.stringify(false));
        }
        this.tmaService.notificationAllowed(null);
        console.error('Unable to get permission to notify.', err);
      }
    );
  }

  /**
   * hook method when new notification received in foreground
   */
  // receiveMessage() {
    
  //   this.angularFireMessaging.messages.subscribe(
  //     (payload) => {
        
  //       console.log("new message received. ", payload);
  //       console.log(payload['notification'].title);

  //       if(payload['data'].tiponotificacao == 'chat'){
  //         //não há necessidade de exibir alerta
  //       }
  //       else{
  //         let infoPush = this.customDia.open(AlertaSimplesDialog, {
  //           width: '300px',
  //           data: {textoAlerta: payload['notification'].title + "<br>" + payload['notification'].body}
  //         });
  //       }
  //       this.currentMessage.next(payload);
  //     })
  // }

  // receiveMessage() {
  //   this.angularFireMessaging.messages.subscribe(
  //     (payload) => {
  //       // console.log("new message received. ", payload);
  //       // console.log(payload['notification'].title);
  //       //alerta not ok for now
  //       // const dialogNewPush = this.dialog.open(AlertaSimplesDialog, {
  //       //     width: '300px',
  //       //     data: {textoAlerta: payload['notification'].title + "<br>" + payload['notification'].body}
  //       // });

  //       this.currentMessage.next(payload);
  //     })
  // }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (payload) => {
        console.log("new message received. ", payload);
        console.log(payload['notification'].title);
        if(payload['data'].tiponotificacao !== 'chat'){
          console.log("call push from app");
          this.exibirAlertaFromPush(payload['notification'].title,payload['notification'].body);
          this.currentMessage.next(payload);
        }
        else{
          this.currentMessage.next(payload);
        }
      })
  }

  exibirAlertaFromPush(titNotify: string, textoNotify: string) :void{
    console.log("its time again again");
    //criar um modal fake
    //alert(textoNotify);
    //AlertaFromPushDialog
    this.ngZone.run(() => {
      let someDialog = this.md.open(AlertaSimplesDialog, {
        width: '300px',
        autoFocus: false,
        disableClose: false,
        data: {tituloAlerta: titNotify, textoAlerta: textoNotify}
      });
    })
  }
}


export interface AlertaFromPush {
  textoAlerta: string;
  iconAlerta: string;
  tituloAlerta: string;
}

@Component({
  selector: 'alerta-frompush',
  template: `
  <div>
    Seems like not working
  </div>
    <div [innerHTML]="data.textoAlerta">
  </div>
  <div mat-dialog-actions  align="end">
    <button mat-raised-button color="primary" (click)="onNoClick()" cdkFocusInitial >OK</button>
  </div>
`,
  styleUrls: ['./alerta-simples.css']
})

export class AlertaFromPushDialog {
  
  constructor(
    public dialogRef: MatDialogRef<AlertaFromPushDialog>,
    @Inject(MAT_DIALOG_DATA) public data: AlertaFromPush) {}

  onInit(){
    if(this.data.tituloAlerta == undefined){
      this.data.tituloAlerta = "Aviso";
    }
  }
  onNoClick(): void {
    console.log("fechar alerta");
    this.dialogRef.close();
  }

}